<template>
    <Intersect
        :threshold="[0, 0]"
        @leave="pauseVideo"
        @enter="playVideo">
        <section class="full-width background h-90 flex flex-col justify-end">
            <!--Video Background-->
            <background-video
                :video-url="sectionHero.videoSources.videoUrl"
                :video-poster-url="sectionHero.videoSources.videoPosterUrl"
                video-id="hero-background-video"
            />

            <!--Contained section-->
            <div
                class="container flex flex-col tablet:flex-row pb-12 desktop:pb-40 hd:pb-24">
                <!--Aside Block -- Content Text Aside Component -->
                <content-text-aside
                    class="phone:w-1/2 tablet:w-1/4  max-w-xxs mr-10 desktop:mr-32"
                    gold>
                    <template #title-text>
                        <span class="font-bold text-xs text-gray-500">{{ sectionHero.heroContent.sideTitleText }}</span>
                    </template>
                </content-text-aside>

                <!--Content Block Sub-layout -->
                <div class="section-text-with-button flex flex-col items-start">
                    <!--Content Text Component-->
                    <content-text>
                        <template #title-text>
                            <h2 class="font-bold phone:text-2xl">
                                {{ sectionHero.heroContent.mainTitleText }}
                            </h2>
                        </template>
                        <template #subtitle-text>
                            <h2 class="font-light phone:text-2xl">
                                {{ sectionHero.heroContent.mainSubtitleText }}
                            </h2>
                        </template>
                    </content-text>

                    <cta-button
                        :url="route('web.registration')"
                        :full-redirect="true"
                        :text="sectionHero.heroContent.buttonText"
                    />
                    <div class="uppercase mt-4 opacity-75 text-sm">
                        {{ sectionHero.heroContent.scrollDownLabel }}
                    </div>
                </div>
            </div>
            <!--Ends Contained Section-->
        </section>
    </Intersect>
</template>

<script>
import CtaButton from '@whisper/components/buttons/CtaButton';
import BackgroundVideo from '@web/components/BackgroundVideo';
import ContentText from '@web/components/ContentText';
import ContentTextAside from '@web/components/ContentTextAside';
import Intersect from 'vue-intersect';

export default {
  components: {
    CtaButton,
    BackgroundVideo,
    ContentText,
    ContentTextAside,
    Intersect,
  },
  props: {
    sectionHero: {
      type: Object,
      required: true,
      heroContent: {
        type: Object,
        required: true,
      },
      videoSources: {
        type: Object,
        required: true,
      },
    },
  },
  methods: {
    playVideo() {
      document.getElementById('hero-background-video').play();
    },

    pauseVideo() {
      document.getElementById('hero-background-video').pause();
    },
  },
};
</script>

<style scoped>

</style>
